import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PaymentTypeAudit } from '../../+models/company-profile-audit.model';

@Component({
  selector: 'sd-portal-payment-type-audit-list',
  templateUrl: './payment-type-audit-list.component.html',
  styleUrls: ['./payment-type-audit-list.component.scss']
})
export class PaymentTypeAuditListComponent implements OnInit {
  @Input() paymentTypeId: number;
  @Input() loading: boolean;
  @Input() paymentTypeAudits: PaymentTypeAudit[];

  @Output() loadPaymentType = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadPaymentType.emit(this.paymentTypeId);
  }

  onNextPage() {
    this.nextPage.emit(this.paymentTypeId);
  }
}
